import { formatAccountTimestamp } from "../_constants/accounts.const";

/** Stripe timestamps are Unix seconds; app timestamps are often ms. */
export function formatAdminDate(ts: number | undefined | null): string {
  if (ts == null) return "—";
  const ms = ts < 1e12 ? ts * 1000 : ts;
  return formatAccountTimestamp(ms);
}

export function formatMoneyCents(
  amountCents: number | null | undefined,
  currency: string | null | undefined
): string {
  if (amountCents == null) return "—";
  const code = (currency ?? "usd").toUpperCase();
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency: code }).format(
      amountCents / 100
    );
  } catch {
    return `${(amountCents / 100).toFixed(2)} ${code}`;
  }
}

export function humanizeInterval(interval: string | null | undefined): string {
  if (!interval) return "—";
  if (interval === "month") return "Monthly";
  if (interval === "year") return "Yearly";
  return interval;
}
